import React, { useEffect, useState } from "react";
import {
  Grid,
  Card,
  Typography,
  CardHeader,
  CardContent,
  Stack,
  Box,
  Divider,
  Avatar,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import errorHandler from "../../utils/errorHandler";
import CardLayout from "../../layouts/CardLayout";
import { IMAGE_BASE } from "../../utils/constants";
import { apiCategory } from "../../services/AllServices";

const ViewSubLastCategory = () => {
  const { id } = useParams();
  const [data, setData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiCategory.getById({ id: id });
        setData(response?.data?.data);
      } catch (error) {
        errorHandler(error);
      }
    };

    fetchData();
  }, [id]);

  // Helper to format ISO date strings to readable format
  const formatDate = (isoDate) =>
    isoDate ? new Date(isoDate).toLocaleString() : "-";

  return (
    <Box>
      <Helmet>
        <title>View Sub Category</title>
      </Helmet>
      <CardLayout>
        <CardHeader title="View Sub Category" />
        <CardContent>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12 }} md={12}>
              <Card sx={{ boxShadow: 4, borderRadius: 3, overflow: "hidden" }}>
                <CardContent>
                  <Stack spacing={3} alignItems="center" mb={3}>
                    <Grid container spacing={2} justifyContent="center">
                      {Array.isArray(data?.categoryImage) &&
                        data.categoryImage.map((img, index) => (
                          <Grid item key={index}>
                            <Avatar
                              variant="rounded"
                              src={IMAGE_BASE + img}
                              alt={`Category Image ${index + 1}`}
                              sx={{ width: 120, height: 120 }}
                            />
                          </Grid>
                        ))}
                    </Grid>
                  </Stack>

                  <Stack spacing={2}>
                    <Typography variant="h6">Name</Typography>
                    <Typography variant="body1" sx={{ overflowWrap: "break-word" }}>
                      {data?.name || "-"}
                    </Typography>
                    <Divider />

                    <Typography variant="h6">Description</Typography>
                    <Typography variant="body1" sx={{ overflowWrap: "break-word" }}>
                      {data?.description || "-"}
                    </Typography>
                    <Divider />

                    <Typography variant="h6">Listing Count</Typography>
                    <Typography variant="body1">{data?.listingCount ?? "-"}</Typography>
                    <Divider />

                    <Typography variant="h6">Status</Typography>
                    <Typography variant="body1">
                      {data?.status === 1 ? "Active" : "Inactive"}
                    </Typography>
                    <Divider />

                    <Typography variant="h6">Created At</Typography>
                    <Typography variant="body1">{formatDate(data?.createdAt)}</Typography>
                    <Divider />

                    <Typography variant="h6">Updated At</Typography>
                    <Typography variant="body1">{formatDate(data?.updatedAt)}</Typography>
                    <Divider />
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </CardContent>
      </CardLayout>
    </Box>
  );
};

export default ViewSubLastCategory;
